import { OrderScreen } from '@fhs/cart';

export default OrderScreen;
